var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 196,
    viewBox: "0 0 122 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.694 188.363C53.3099 192.553 56.6886 195.999 60.9236 195.999C65.1586 195.999 68.5374 192.553 69.1532 188.363C70.8123 177.073 76.0659 166.539 84.2382 158.384C92.4101 150.229 102.954 144.998 114.246 143.363C118.436 142.757 121.885 139.382 121.885 135.148C121.885 130.916 118.444 127.441 114.238 127.912C106.663 128.761 99.2644 130.87 92.3534 134.169C83.1311 138.572 75.011 144.982 68.587 152.93L68.587 7.66278C68.587 3.43045 65.156 -0.000539017 60.9237 -0.000539387C56.6913 -0.000539757 53.2603 3.43044 53.2603 7.66277L53.2603 153.044C46.8376 145.067 38.709 138.631 29.4724 134.208C22.5446 130.891 15.1252 128.769 7.52782 127.915C3.32459 127.442 -0.115349 130.915 -0.115349 135.145C-0.115349 139.378 3.33725 142.752 7.52769 143.353C18.8334 144.974 29.3947 150.2 37.581 158.358C45.7686 166.516 51.0328 177.061 52.694 188.363Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 196,
    fill: "white",
    transform: "translate(122 196) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b2da406e.svg";
export { ForwardRef as ReactComponent };